import { createAction } from 'redux-actions'
import Api from '../Api'

import { setAlert } from './alerts'

export const REQUEST_EVENT_LIST = createAction('REQUEST_EVENT_LIST')
export const RECEIVE_EVENT_LIST = createAction('RECEIVE_EVENT_LIST', list => list)
export const REQUEST_RIDER_LIST = createAction('REQUEST_RIDER_LIST')
export const RECEIVE_RIDER_LIST = createAction('RECEIVE_RIDER_LIST', list => list)

export const fetchEventList = () => {
  return (dispatch) => {
    dispatch(REQUEST_EVENT_LIST())

    return Api.getEventList()
      .then(response => dispatch(RECEIVE_EVENT_LIST({data: response.data})))
      .catch(error => {
        const errorMessage = error.response.data.message === "Technical error"
          ? "Sorry, we are undergoing maintenance. Please check back soon."
          : error.response.data.message

        dispatch(setAlert(errorMessage, undefined, 'error'))
      })
  }
}

export const fetchRiderList = () => {
  return (dispatch) => {
    dispatch(REQUEST_RIDER_LIST())

    return Api.getRiderList()
      .then(response => dispatch(RECEIVE_RIDER_LIST({data: response.data})))
      .catch(error => {
        const errorMessage = error.response.data.message === "Technical error"
          ? "Sorry, we are undergoing maintenance. Please check back soon."
          : error.response.data.message

        dispatch(setAlert(errorMessage, undefined, 'error'))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/library.js